export const homeDetailsSelectors = {
  item: (state) => state.item,
  update: (state) => state.update,
}
